var cov_g1cjev3dz = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Input/Input.tsx",
      hash = "407d4bb163ef13f467b38eeb0476266d3539b471",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Input/Input.tsx",
    statementMap: {
      "0": {
        start: {
          line: 12,
          column: 2
        },
        end: {
          line: 12,
          column: 68
        }
      },
      "1": {
        start: {
          line: 16,
          column: 2
        },
        end: {
          line: 22,
          column: 3
        }
      },
      "2": {
        start: {
          line: 25,
          column: 21
        },
        end: {
          line: 27,
          column: 1
        }
      },
      "3": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 39,
          column: 16
        }
      },
      "4": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 40,
          column: 26
        }
      },
      "5": {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 41,
          column: 52
        }
      },
      "6": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 54
        }
      },
      "7": {
        start: {
          line: 43,
          column: 4
        },
        end: {
          line: 43,
          column: 50
        }
      },
      "8": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 44,
          column: 48
        }
      },
      "9": {
        start: {
          line: 45,
          column: 4
        },
        end: {
          line: 45,
          column: 60
        }
      },
      "10": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 42
        }
      },
      "11": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 50,
          column: 49
        }
      },
      "12": {
        start: {
          line: 50,
          column: 38
        },
        end: {
          line: 50,
          column: 49
        }
      },
      "13": {
        start: {
          line: 51,
          column: 21
        },
        end: {
          line: 51,
          column: 31
        }
      },
      "14": {
        start: {
          line: 52,
          column: 17
        },
        end: {
          line: 52,
          column: 44
        }
      },
      "15": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 53,
          column: 69
        }
      },
      "16": {
        start: {
          line: 53,
          column: 58
        },
        end: {
          line: 53,
          column: 69
        }
      },
      "17": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 54,
          column: 26
        }
      },
      "18": {
        start: {
          line: 58,
          column: 29
        },
        end: {
          line: 58,
          column: 39
        }
      },
      "19": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 59,
          column: 17
        }
      },
      "20": {
        start: {
          line: 60,
          column: 4
        },
        end: {
          line: 60,
          column: 38
        }
      },
      "21": {
        start: {
          line: 60,
          column: 22
        },
        end: {
          line: 60,
          column: 38
        }
      },
      "22": {
        start: {
          line: 64,
          column: 21
        },
        end: {
          line: 64,
          column: 31
        }
      },
      "23": {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 65,
          column: 39
        }
      },
      "24": {
        start: {
          line: 65,
          column: 28
        },
        end: {
          line: 65,
          column: 39
        }
      },
      "25": {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 66,
          column: 53
        }
      },
      "26": {
        start: {
          line: 66,
          column: 35
        },
        end: {
          line: 66,
          column: 53
        }
      },
      "27": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 67,
          column: 16
        }
      },
      "28": {
        start: {
          line: 71,
          column: 24
        },
        end: {
          line: 71,
          column: 34
        }
      },
      "29": {
        start: {
          line: 72,
          column: 18
        },
        end: {
          line: 72,
          column: 70
        }
      },
      "30": {
        start: {
          line: 73,
          column: 19
        },
        end: {
          line: 73,
          column: 74
        }
      },
      "31": {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 74,
          column: 27
        }
      },
      "32": {
        start: {
          line: 78,
          column: 16
        },
        end: {
          line: 78,
          column: 19
        }
      },
      "33": {
        start: {
          line: 79,
          column: 52
        },
        end: {
          line: 79,
          column: 62
        }
      },
      "34": {
        start: {
          line: 80,
          column: 18
        },
        end: {
          line: 80,
          column: 70
        }
      },
      "35": {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 81,
          column: 39
        }
      },
      "36": {
        start: {
          line: 81,
          column: 27
        },
        end: {
          line: 81,
          column: 39
        }
      },
      "37": {
        start: {
          line: 83,
          column: 19
        },
        end: {
          line: 86,
          column: 5
        }
      },
      "38": {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 88,
          column: 43
        }
      },
      "39": {
        start: {
          line: 89,
          column: 4
        },
        end: {
          line: 89,
          column: 16
        }
      },
      "40": {
        start: {
          line: 93,
          column: 47
        },
        end: {
          line: 93,
          column: 57
        }
      },
      "41": {
        start: {
          line: 94,
          column: 4
        },
        end: {
          line: 94,
          column: 51
        }
      },
      "42": {
        start: {
          line: 94,
          column: 41
        },
        end: {
          line: 94,
          column: 51
        }
      },
      "43": {
        start: {
          line: 95,
          column: 4
        },
        end: {
          line: 95,
          column: 38
        }
      },
      "44": {
        start: {
          line: 95,
          column: 29
        },
        end: {
          line: 95,
          column: 38
        }
      },
      "45": {
        start: {
          line: 96,
          column: 17
        },
        end: {
          line: 96,
          column: 32
        }
      },
      "46": {
        start: {
          line: 97,
          column: 4
        },
        end: {
          line: 97,
          column: 64
        }
      },
      "47": {
        start: {
          line: 97,
          column: 55
        },
        end: {
          line: 97,
          column: 64
        }
      },
      "48": {
        start: {
          line: 99,
          column: 4
        },
        end: {
          line: 105,
          column: 5
        }
      },
      "49": {
        start: {
          line: 100,
          column: 6
        },
        end: {
          line: 104,
          column: 7
        }
      },
      "50": {
        start: {
          line: 101,
          column: 8
        },
        end: {
          line: 101,
          column: 51
        }
      },
      "51": {
        start: {
          line: 103,
          column: 8
        },
        end: {
          line: 103,
          column: 48
        }
      },
      "52": {
        start: {
          line: 106,
          column: 4
        },
        end: {
          line: 106,
          column: 17
        }
      },
      "53": {
        start: {
          line: 110,
          column: 43
        },
        end: {
          line: 110,
          column: 53
        }
      },
      "54": {
        start: {
          line: 111,
          column: 4
        },
        end: {
          line: 111,
          column: 39
        }
      },
      "55": {
        start: {
          line: 111,
          column: 27
        },
        end: {
          line: 111,
          column: 39
        }
      },
      "56": {
        start: {
          line: 113,
          column: 31
        },
        end: {
          line: 113,
          column: 36
        }
      },
      "57": {
        start: {
          line: 114,
          column: 4
        },
        end: {
          line: 118,
          column: 5
        }
      },
      "58": {
        start: {
          line: 115,
          column: 6
        },
        end: {
          line: 115,
          column: 19
        }
      },
      "59": {
        start: {
          line: 116,
          column: 11
        },
        end: {
          line: 118,
          column: 5
        }
      },
      "60": {
        start: {
          line: 117,
          column: 6
        },
        end: {
          line: 117,
          column: 37
        }
      },
      "61": {
        start: {
          line: 120,
          column: 4
        },
        end: {
          line: 124,
          column: 5
        }
      },
      "62": {
        start: {
          line: 121,
          column: 6
        },
        end: {
          line: 121,
          column: 23
        }
      },
      "63": {
        start: {
          line: 122,
          column: 11
        },
        end: {
          line: 124,
          column: 5
        }
      },
      "64": {
        start: {
          line: 123,
          column: 6
        },
        end: {
          line: 123,
          column: 35
        }
      },
      "65": {
        start: {
          line: 125,
          column: 4
        },
        end: {
          line: 125,
          column: 14
        }
      },
      "66": {
        start: {
          line: 126,
          column: 4
        },
        end: {
          line: 126,
          column: 25
        }
      },
      "67": {
        start: {
          line: 127,
          column: 4
        },
        end: {
          line: 127,
          column: 27
        }
      },
      "68": {
        start: {
          line: 131,
          column: 38
        },
        end: {
          line: 131,
          column: 48
        }
      },
      "69": {
        start: {
          line: 132,
          column: 4
        },
        end: {
          line: 135,
          column: 5
        }
      },
      "70": {
        start: {
          line: 133,
          column: 6
        },
        end: {
          line: 133,
          column: 22
        }
      },
      "71": {
        start: {
          line: 134,
          column: 6
        },
        end: {
          line: 134,
          column: 54
        }
      },
      "72": {
        start: {
          line: 134,
          column: 43
        },
        end: {
          line: 134,
          column: 54
        }
      },
      "73": {
        start: {
          line: 136,
          column: 20
        },
        end: {
          line: 136,
          column: 48
        }
      },
      "74": {
        start: {
          line: 137,
          column: 4
        },
        end: {
          line: 140,
          column: 5
        }
      },
      "75": {
        start: {
          line: 138,
          column: 6
        },
        end: {
          line: 138,
          column: 32
        }
      },
      "76": {
        start: {
          line: 139,
          column: 6
        },
        end: {
          line: 139,
          column: 12
        }
      },
      "77": {
        start: {
          line: 142,
          column: 4
        },
        end: {
          line: 153,
          column: 5
        }
      },
      "78": {
        start: {
          line: 143,
          column: 6
        },
        end: {
          line: 148,
          column: 7
        }
      },
      "79": {
        start: {
          line: 144,
          column: 8
        },
        end: {
          line: 144,
          column: 48
        }
      },
      "80": {
        start: {
          line: 145,
          column: 8
        },
        end: {
          line: 147,
          column: 9
        }
      },
      "81": {
        start: {
          line: 146,
          column: 10
        },
        end: {
          line: 146,
          column: 41
        }
      },
      "82": {
        start: {
          line: 149,
          column: 6
        },
        end: {
          line: 151,
          column: 7
        }
      },
      "83": {
        start: {
          line: 150,
          column: 8
        },
        end: {
          line: 150,
          column: 14
        }
      },
      "84": {
        start: {
          line: 152,
          column: 6
        },
        end: {
          line: 152,
          column: 37
        }
      },
      "85": {
        start: {
          line: 155,
          column: 4
        },
        end: {
          line: 155,
          column: 30
        }
      },
      "86": {
        start: {
          line: 159,
          column: 26
        },
        end: {
          line: 159,
          column: 36
        }
      },
      "87": {
        start: {
          line: 160,
          column: 4
        },
        end: {
          line: 160,
          column: 48
        }
      },
      "88": {
        start: {
          line: 160,
          column: 26
        },
        end: {
          line: 160,
          column: 48
        }
      },
      "89": {
        start: {
          line: 161,
          column: 4
        },
        end: {
          line: 161,
          column: 31
        }
      },
      "90": {
        start: {
          line: 161,
          column: 19
        },
        end: {
          line: 161,
          column: 31
        }
      },
      "91": {
        start: {
          line: 165,
          column: 38
        },
        end: {
          line: 165,
          column: 48
        }
      },
      "92": {
        start: {
          line: 166,
          column: 4
        },
        end: {
          line: 169,
          column: 5
        }
      },
      "93": {
        start: {
          line: 167,
          column: 6
        },
        end: {
          line: 167,
          column: 59
        }
      },
      "94": {
        start: {
          line: 168,
          column: 6
        },
        end: {
          line: 168,
          column: 29
        }
      },
      "95": {
        start: {
          line: 170,
          column: 4
        },
        end: {
          line: 170,
          column: 27
        }
      },
      "96": {
        start: {
          line: 170,
          column: 17
        },
        end: {
          line: 170,
          column: 27
        }
      },
      "97": {
        start: {
          line: 174,
          column: 22
        },
        end: {
          line: 174,
          column: 50
        }
      },
      "98": {
        start: {
          line: 175,
          column: 64
        },
        end: {
          line: 175,
          column: 74
        }
      },
      "99": {
        start: {
          line: 176,
          column: 17
        },
        end: {
          line: 176,
          column: 37
        }
      },
      "100": {
        start: {
          line: 177,
          column: 32
        },
        end: {
          line: 177,
          column: 99
        }
      },
      "101": {
        start: {
          line: 178,
          column: 4
        },
        end: {
          line: 184,
          column: 5
        }
      },
      "102": {
        start: {
          line: 179,
          column: 6
        },
        end: {
          line: 179,
          column: 48
        }
      },
      "103": {
        start: {
          line: 179,
          column: 26
        },
        end: {
          line: 179,
          column: 48
        }
      },
      "104": {
        start: {
          line: 180,
          column: 21
        },
        end: {
          line: 180,
          column: 44
        }
      },
      "105": {
        start: {
          line: 182,
          column: 6
        },
        end: {
          line: 182,
          column: 54
        }
      },
      "106": {
        start: {
          line: 182,
          column: 40
        },
        end: {
          line: 182,
          column: 54
        }
      },
      "107": {
        start: {
          line: 183,
          column: 6
        },
        end: {
          line: 183,
          column: 29
        }
      },
      "108": {
        start: {
          line: 185,
          column: 4
        },
        end: {
          line: 185,
          column: 25
        }
      },
      "109": {
        start: {
          line: 185,
          column: 16
        },
        end: {
          line: 185,
          column: 25
        }
      },
      "110": {
        start: {
          line: 189,
          column: 24
        },
        end: {
          line: 189,
          column: 34
        }
      },
      "111": {
        start: {
          line: 190,
          column: 27
        },
        end: {
          line: 190,
          column: 37
        }
      },
      "112": {
        start: {
          line: 191,
          column: 4
        },
        end: {
          line: 193,
          column: 5
        }
      },
      "113": {
        start: {
          line: 192,
          column: 7
        },
        end: {
          line: 192,
          column: 57
        }
      },
      "114": {
        start: {
          line: 194,
          column: 4
        },
        end: {
          line: 196,
          column: 5
        }
      },
      "115": {
        start: {
          line: 195,
          column: 6
        },
        end: {
          line: 195,
          column: 20
        }
      },
      "116": {
        start: {
          line: 200,
          column: 21
        },
        end: {
          line: 200,
          column: 31
        }
      },
      "117": {
        start: {
          line: 201,
          column: 22
        },
        end: {
          line: 201,
          column: 46
        }
      },
      "118": {
        start: {
          line: 203,
          column: 4
        },
        end: {
          line: 203,
          column: 60
        }
      },
      "119": {
        start: {
          line: 203,
          column: 49
        },
        end: {
          line: 203,
          column: 60
        }
      },
      "120": {
        start: {
          line: 205,
          column: 21
        },
        end: {
          line: 205,
          column: 56
        }
      },
      "121": {
        start: {
          line: 206,
          column: 16
        },
        end: {
          line: 206,
          column: 42
        }
      },
      "122": {
        start: {
          line: 209,
          column: 4
        },
        end: {
          line: 209,
          column: 25
        }
      },
      "123": {
        start: {
          line: 209,
          column: 14
        },
        end: {
          line: 209,
          column: 25
        }
      },
      "124": {
        start: {
          line: 211,
          column: 20
        },
        end: {
          line: 211,
          column: 40
        }
      },
      "125": {
        start: {
          line: 212,
          column: 17
        },
        end: {
          line: 212,
          column: 44
        }
      },
      "126": {
        start: {
          line: 213,
          column: 4
        },
        end: {
          line: 217,
          column: 5
        }
      },
      "127": {
        start: {
          line: 239,
          column: 8
        },
        end: {
          line: 239,
          column: 18
        }
      },
      "128": {
        start: {
          line: 240,
          column: 18
        },
        end: {
          line: 240,
          column: 100
        }
      },
      "129": {
        start: {
          line: 241,
          column: 31
        },
        end: {
          line: 241,
          column: 81
        }
      },
      "130": {
        start: {
          line: 242,
          column: 22
        },
        end: {
          line: 242,
          column: 90
        }
      },
      "131": {
        start: {
          line: 243,
          column: 15
        },
        end: {
          line: 247,
          column: 5
        }
      },
      "132": {
        start: {
          line: 248,
          column: 21
        },
        end: {
          line: 248,
          column: 78
        }
      },
      "133": {
        start: {
          line: 249,
          column: 4
        },
        end: {
          line: 274,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "regLength",
        decl: {
          start: {
            line: 11,
            column: 9
          },
          end: {
            line: 11,
            column: 18
          }
        },
        loc: {
          start: {
            line: 11,
            column: 34
          },
          end: {
            line: 13,
            column: 1
          }
        },
        line: 11
      },
      "1": {
        name: "fillNumber",
        decl: {
          start: {
            line: 15,
            column: 9
          },
          end: {
            line: 15,
            column: 19
          }
        },
        loc: {
          start: {
            line: 15,
            column: 33
          },
          end: {
            line: 23,
            column: 1
          }
        },
        line: 15
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 38,
            column: 2
          },
          end: {
            line: 38,
            column: 3
          }
        },
        loc: {
          start: {
            line: 38,
            column: 28
          },
          end: {
            line: 47,
            column: 3
          }
        },
        line: 38
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 49,
            column: 16
          },
          end: {
            line: 49,
            column: 17
          }
        },
        loc: {
          start: {
            line: 49,
            column: 36
          },
          end: {
            line: 55,
            column: 3
          }
        },
        line: 49
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 57,
            column: 2
          },
          end: {
            line: 57,
            column: 3
          }
        },
        loc: {
          start: {
            line: 57,
            column: 32
          },
          end: {
            line: 61,
            column: 3
          }
        },
        line: 57
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 63,
            column: 12
          },
          end: {
            line: 63,
            column: 13
          }
        },
        loc: {
          start: {
            line: 63,
            column: 18
          },
          end: {
            line: 68,
            column: 3
          }
        },
        line: 63
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 70,
            column: 2
          },
          end: {
            line: 70,
            column: 3
          }
        },
        loc: {
          start: {
            line: 70,
            column: 29
          },
          end: {
            line: 75,
            column: 3
          }
        },
        line: 70
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 77,
            column: 2
          },
          end: {
            line: 77,
            column: 3
          }
        },
        loc: {
          start: {
            line: 77,
            column: 27
          },
          end: {
            line: 90,
            column: 3
          }
        },
        line: 77
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 92,
            column: 2
          },
          end: {
            line: 92,
            column: 3
          }
        },
        loc: {
          start: {
            line: 92,
            column: 24
          },
          end: {
            line: 107,
            column: 3
          }
        },
        line: 92
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 109,
            column: 2
          },
          end: {
            line: 109,
            column: 3
          }
        },
        loc: {
          start: {
            line: 109,
            column: 31
          },
          end: {
            line: 128,
            column: 3
          }
        },
        line: 109
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 130,
            column: 2
          },
          end: {
            line: 130,
            column: 3
          }
        },
        loc: {
          start: {
            line: 130,
            column: 58
          },
          end: {
            line: 156,
            column: 3
          }
        },
        line: 130
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 158,
            column: 2
          },
          end: {
            line: 158,
            column: 3
          }
        },
        loc: {
          start: {
            line: 158,
            column: 40
          },
          end: {
            line: 162,
            column: 3
          }
        },
        line: 158
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 164,
            column: 2
          },
          end: {
            line: 164,
            column: 3
          }
        },
        loc: {
          start: {
            line: 164,
            column: 38
          },
          end: {
            line: 171,
            column: 3
          }
        },
        line: 164
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 173,
            column: 2
          },
          end: {
            line: 173,
            column: 3
          }
        },
        loc: {
          start: {
            line: 173,
            column: 52
          },
          end: {
            line: 186,
            column: 3
          }
        },
        line: 173
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 188,
            column: 2
          },
          end: {
            line: 188,
            column: 3
          }
        },
        loc: {
          start: {
            line: 188,
            column: 44
          },
          end: {
            line: 197,
            column: 3
          }
        },
        line: 188
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 199,
            column: 2
          },
          end: {
            line: 199,
            column: 3
          }
        },
        loc: {
          start: {
            line: 199,
            column: 15
          },
          end: {
            line: 218,
            column: 3
          }
        },
        line: 199
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 220,
            column: 2
          },
          end: {
            line: 220,
            column: 3
          }
        },
        loc: {
          start: {
            line: 220,
            column: 11
          },
          end: {
            line: 275,
            column: 3
          }
        },
        line: 220
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 12,
            column: 9
          },
          end: {
            line: 12,
            column: 68
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 12,
            column: 49
          },
          end: {
            line: 12,
            column: 62
          }
        }, {
          start: {
            line: 12,
            column: 65
          },
          end: {
            line: 12,
            column: 68
          }
        }],
        line: 12
      },
      "1": {
        loc: {
          start: {
            line: 12,
            column: 9
          },
          end: {
            line: 12,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 12,
            column: 9
          },
          end: {
            line: 12,
            column: 33
          }
        }, {
          start: {
            line: 12,
            column: 37
          },
          end: {
            line: 12,
            column: 46
          }
        }],
        line: 12
      },
      "2": {
        loc: {
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 50,
            column: 49
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 50,
            column: 49
          }
        }, {
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 50,
            column: 49
          }
        }],
        line: 50
      },
      "3": {
        loc: {
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 50,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 50,
            column: 8
          },
          end: {
            line: 50,
            column: 14
          }
        }, {
          start: {
            line: 50,
            column: 18
          },
          end: {
            line: 50,
            column: 36
          }
        }],
        line: 50
      },
      "4": {
        loc: {
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 53,
            column: 69
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 53,
            column: 69
          }
        }, {
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 53,
            column: 69
          }
        }],
        line: 53
      },
      "5": {
        loc: {
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 53,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 53,
            column: 32
          }
        }, {
          start: {
            line: 53,
            column: 36
          },
          end: {
            line: 53,
            column: 56
          }
        }],
        line: 53
      },
      "6": {
        loc: {
          start: {
            line: 60,
            column: 4
          },
          end: {
            line: 60,
            column: 38
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 60,
            column: 4
          },
          end: {
            line: 60,
            column: 38
          }
        }, {
          start: {
            line: 60,
            column: 4
          },
          end: {
            line: 60,
            column: 38
          }
        }],
        line: 60
      },
      "7": {
        loc: {
          start: {
            line: 65,
            column: 4
          },
          end: {
            line: 65,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 65,
            column: 4
          },
          end: {
            line: 65,
            column: 39
          }
        }, {
          start: {
            line: 65,
            column: 4
          },
          end: {
            line: 65,
            column: 39
          }
        }],
        line: 65
      },
      "8": {
        loc: {
          start: {
            line: 66,
            column: 4
          },
          end: {
            line: 66,
            column: 53
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 66,
            column: 4
          },
          end: {
            line: 66,
            column: 53
          }
        }, {
          start: {
            line: 66,
            column: 4
          },
          end: {
            line: 66,
            column: 53
          }
        }],
        line: 66
      },
      "9": {
        loc: {
          start: {
            line: 72,
            column: 18
          },
          end: {
            line: 72,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 72,
            column: 18
          },
          end: {
            line: 72,
            column: 44
          }
        }, {
          start: {
            line: 72,
            column: 48
          },
          end: {
            line: 72,
            column: 70
          }
        }],
        line: 72
      },
      "10": {
        loc: {
          start: {
            line: 73,
            column: 35
          },
          end: {
            line: 73,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 73,
            column: 43
          },
          end: {
            line: 73,
            column: 45
          }
        }, {
          start: {
            line: 73,
            column: 48
          },
          end: {
            line: 73,
            column: 51
          }
        }],
        line: 73
      },
      "11": {
        loc: {
          start: {
            line: 80,
            column: 18
          },
          end: {
            line: 80,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 80,
            column: 18
          },
          end: {
            line: 80,
            column: 44
          }
        }, {
          start: {
            line: 80,
            column: 48
          },
          end: {
            line: 80,
            column: 70
          }
        }],
        line: 80
      },
      "12": {
        loc: {
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 81,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 81,
            column: 39
          }
        }, {
          start: {
            line: 81,
            column: 4
          },
          end: {
            line: 81,
            column: 39
          }
        }],
        line: 81
      },
      "13": {
        loc: {
          start: {
            line: 84,
            column: 11
          },
          end: {
            line: 84,
            column: 27
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 84,
            column: 19
          },
          end: {
            line: 84,
            column: 21
          }
        }, {
          start: {
            line: 84,
            column: 24
          },
          end: {
            line: 84,
            column: 27
          }
        }],
        line: 84
      },
      "14": {
        loc: {
          start: {
            line: 84,
            column: 64
          },
          end: {
            line: 84,
            column: 112
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 84,
            column: 79
          },
          end: {
            line: 84,
            column: 107
          }
        }, {
          start: {
            line: 84,
            column: 110
          },
          end: {
            line: 84,
            column: 112
          }
        }],
        line: 84
      },
      "15": {
        loc: {
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 94,
            column: 51
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 94,
            column: 51
          }
        }, {
          start: {
            line: 94,
            column: 4
          },
          end: {
            line: 94,
            column: 51
          }
        }],
        line: 94
      },
      "16": {
        loc: {
          start: {
            line: 94,
            column: 8
          },
          end: {
            line: 94,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 94,
            column: 8
          },
          end: {
            line: 94,
            column: 25
          }
        }, {
          start: {
            line: 94,
            column: 29
          },
          end: {
            line: 94,
            column: 39
          }
        }],
        line: 94
      },
      "17": {
        loc: {
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 95,
            column: 38
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 95,
            column: 38
          }
        }, {
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 95,
            column: 38
          }
        }],
        line: 95
      },
      "18": {
        loc: {
          start: {
            line: 97,
            column: 4
          },
          end: {
            line: 97,
            column: 64
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 97,
            column: 4
          },
          end: {
            line: 97,
            column: 64
          }
        }, {
          start: {
            line: 97,
            column: 4
          },
          end: {
            line: 97,
            column: 64
          }
        }],
        line: 97
      },
      "19": {
        loc: {
          start: {
            line: 97,
            column: 8
          },
          end: {
            line: 97,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 97,
            column: 8
          },
          end: {
            line: 97,
            column: 30
          }
        }, {
          start: {
            line: 97,
            column: 34
          },
          end: {
            line: 97,
            column: 53
          }
        }],
        line: 97
      },
      "20": {
        loc: {
          start: {
            line: 99,
            column: 4
          },
          end: {
            line: 105,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 99,
            column: 4
          },
          end: {
            line: 105,
            column: 5
          }
        }, {
          start: {
            line: 99,
            column: 4
          },
          end: {
            line: 105,
            column: 5
          }
        }],
        line: 99
      },
      "21": {
        loc: {
          start: {
            line: 99,
            column: 8
          },
          end: {
            line: 99,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 99,
            column: 8
          },
          end: {
            line: 99,
            column: 28
          }
        }, {
          start: {
            line: 99,
            column: 32
          },
          end: {
            line: 99,
            column: 39
          }
        }],
        line: 99
      },
      "22": {
        loc: {
          start: {
            line: 100,
            column: 6
          },
          end: {
            line: 104,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 100,
            column: 6
          },
          end: {
            line: 104,
            column: 7
          }
        }, {
          start: {
            line: 100,
            column: 6
          },
          end: {
            line: 104,
            column: 7
          }
        }],
        line: 100
      },
      "23": {
        loc: {
          start: {
            line: 111,
            column: 4
          },
          end: {
            line: 111,
            column: 39
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 111,
            column: 4
          },
          end: {
            line: 111,
            column: 39
          }
        }, {
          start: {
            line: 111,
            column: 4
          },
          end: {
            line: 111,
            column: 39
          }
        }],
        line: 111
      },
      "24": {
        loc: {
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 118,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 118,
            column: 5
          }
        }, {
          start: {
            line: 114,
            column: 4
          },
          end: {
            line: 118,
            column: 5
          }
        }],
        line: 114
      },
      "25": {
        loc: {
          start: {
            line: 116,
            column: 11
          },
          end: {
            line: 118,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 116,
            column: 11
          },
          end: {
            line: 118,
            column: 5
          }
        }, {
          start: {
            line: 116,
            column: 11
          },
          end: {
            line: 118,
            column: 5
          }
        }],
        line: 116
      },
      "26": {
        loc: {
          start: {
            line: 120,
            column: 4
          },
          end: {
            line: 124,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 120,
            column: 4
          },
          end: {
            line: 124,
            column: 5
          }
        }, {
          start: {
            line: 120,
            column: 4
          },
          end: {
            line: 124,
            column: 5
          }
        }],
        line: 120
      },
      "27": {
        loc: {
          start: {
            line: 122,
            column: 11
          },
          end: {
            line: 124,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 122,
            column: 11
          },
          end: {
            line: 124,
            column: 5
          }
        }, {
          start: {
            line: 122,
            column: 11
          },
          end: {
            line: 124,
            column: 5
          }
        }],
        line: 122
      },
      "28": {
        loc: {
          start: {
            line: 132,
            column: 4
          },
          end: {
            line: 135,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 132,
            column: 4
          },
          end: {
            line: 135,
            column: 5
          }
        }, {
          start: {
            line: 132,
            column: 4
          },
          end: {
            line: 135,
            column: 5
          }
        }],
        line: 132
      },
      "29": {
        loc: {
          start: {
            line: 134,
            column: 6
          },
          end: {
            line: 134,
            column: 54
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 134,
            column: 6
          },
          end: {
            line: 134,
            column: 54
          }
        }, {
          start: {
            line: 134,
            column: 6
          },
          end: {
            line: 134,
            column: 54
          }
        }],
        line: 134
      },
      "30": {
        loc: {
          start: {
            line: 137,
            column: 4
          },
          end: {
            line: 140,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 137,
            column: 4
          },
          end: {
            line: 140,
            column: 5
          }
        }, {
          start: {
            line: 137,
            column: 4
          },
          end: {
            line: 140,
            column: 5
          }
        }],
        line: 137
      },
      "31": {
        loc: {
          start: {
            line: 137,
            column: 8
          },
          end: {
            line: 137,
            column: 49
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 137,
            column: 8
          },
          end: {
            line: 137,
            column: 18
          }
        }, {
          start: {
            line: 137,
            column: 22
          },
          end: {
            line: 137,
            column: 49
          }
        }],
        line: 137
      },
      "32": {
        loc: {
          start: {
            line: 142,
            column: 4
          },
          end: {
            line: 153,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 142,
            column: 4
          },
          end: {
            line: 153,
            column: 5
          }
        }, {
          start: {
            line: 142,
            column: 4
          },
          end: {
            line: 153,
            column: 5
          }
        }],
        line: 142
      },
      "33": {
        loc: {
          start: {
            line: 143,
            column: 6
          },
          end: {
            line: 148,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 143,
            column: 6
          },
          end: {
            line: 148,
            column: 7
          }
        }, {
          start: {
            line: 143,
            column: 6
          },
          end: {
            line: 148,
            column: 7
          }
        }],
        line: 143
      },
      "34": {
        loc: {
          start: {
            line: 145,
            column: 8
          },
          end: {
            line: 147,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 145,
            column: 8
          },
          end: {
            line: 147,
            column: 9
          }
        }, {
          start: {
            line: 145,
            column: 8
          },
          end: {
            line: 147,
            column: 9
          }
        }],
        line: 145
      },
      "35": {
        loc: {
          start: {
            line: 149,
            column: 6
          },
          end: {
            line: 151,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 149,
            column: 6
          },
          end: {
            line: 151,
            column: 7
          }
        }, {
          start: {
            line: 149,
            column: 6
          },
          end: {
            line: 151,
            column: 7
          }
        }],
        line: 149
      },
      "36": {
        loc: {
          start: {
            line: 160,
            column: 4
          },
          end: {
            line: 160,
            column: 48
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 160,
            column: 4
          },
          end: {
            line: 160,
            column: 48
          }
        }, {
          start: {
            line: 160,
            column: 4
          },
          end: {
            line: 160,
            column: 48
          }
        }],
        line: 160
      },
      "37": {
        loc: {
          start: {
            line: 161,
            column: 4
          },
          end: {
            line: 161,
            column: 31
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 161,
            column: 4
          },
          end: {
            line: 161,
            column: 31
          }
        }, {
          start: {
            line: 161,
            column: 4
          },
          end: {
            line: 161,
            column: 31
          }
        }],
        line: 161
      },
      "38": {
        loc: {
          start: {
            line: 166,
            column: 4
          },
          end: {
            line: 169,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 166,
            column: 4
          },
          end: {
            line: 169,
            column: 5
          }
        }, {
          start: {
            line: 166,
            column: 4
          },
          end: {
            line: 169,
            column: 5
          }
        }],
        line: 166
      },
      "39": {
        loc: {
          start: {
            line: 166,
            column: 8
          },
          end: {
            line: 166,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 166,
            column: 8
          },
          end: {
            line: 166,
            column: 23
          }
        }, {
          start: {
            line: 166,
            column: 27
          },
          end: {
            line: 166,
            column: 43
          }
        }, {
          start: {
            line: 166,
            column: 47
          },
          end: {
            line: 166,
            column: 59
          }
        }],
        line: 166
      },
      "40": {
        loc: {
          start: {
            line: 170,
            column: 4
          },
          end: {
            line: 170,
            column: 27
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 170,
            column: 4
          },
          end: {
            line: 170,
            column: 27
          }
        }, {
          start: {
            line: 170,
            column: 4
          },
          end: {
            line: 170,
            column: 27
          }
        }],
        line: 170
      },
      "41": {
        loc: {
          start: {
            line: 177,
            column: 32
          },
          end: {
            line: 177,
            column: 99
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 177,
            column: 32
          },
          end: {
            line: 177,
            column: 48
          }
        }, {
          start: {
            line: 177,
            column: 52
          },
          end: {
            line: 177,
            column: 65
          }
        }, {
          start: {
            line: 177,
            column: 69
          },
          end: {
            line: 177,
            column: 99
          }
        }],
        line: 177
      },
      "42": {
        loc: {
          start: {
            line: 178,
            column: 4
          },
          end: {
            line: 184,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 178,
            column: 4
          },
          end: {
            line: 184,
            column: 5
          }
        }, {
          start: {
            line: 178,
            column: 4
          },
          end: {
            line: 184,
            column: 5
          }
        }],
        line: 178
      },
      "43": {
        loc: {
          start: {
            line: 178,
            column: 8
          },
          end: {
            line: 178,
            column: 59
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 178,
            column: 8
          },
          end: {
            line: 178,
            column: 28
          }
        }, {
          start: {
            line: 178,
            column: 32
          },
          end: {
            line: 178,
            column: 59
          }
        }],
        line: 178
      },
      "44": {
        loc: {
          start: {
            line: 179,
            column: 6
          },
          end: {
            line: 179,
            column: 48
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 179,
            column: 6
          },
          end: {
            line: 179,
            column: 48
          }
        }, {
          start: {
            line: 179,
            column: 6
          },
          end: {
            line: 179,
            column: 48
          }
        }],
        line: 179
      },
      "45": {
        loc: {
          start: {
            line: 180,
            column: 21
          },
          end: {
            line: 180,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 180,
            column: 21
          },
          end: {
            line: 180,
            column: 32
          }
        }, {
          start: {
            line: 180,
            column: 36
          },
          end: {
            line: 180,
            column: 44
          }
        }],
        line: 180
      },
      "46": {
        loc: {
          start: {
            line: 182,
            column: 6
          },
          end: {
            line: 182,
            column: 54
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 182,
            column: 6
          },
          end: {
            line: 182,
            column: 54
          }
        }, {
          start: {
            line: 182,
            column: 6
          },
          end: {
            line: 182,
            column: 54
          }
        }],
        line: 182
      },
      "47": {
        loc: {
          start: {
            line: 185,
            column: 4
          },
          end: {
            line: 185,
            column: 25
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 185,
            column: 4
          },
          end: {
            line: 185,
            column: 25
          }
        }, {
          start: {
            line: 185,
            column: 4
          },
          end: {
            line: 185,
            column: 25
          }
        }],
        line: 185
      },
      "48": {
        loc: {
          start: {
            line: 191,
            column: 4
          },
          end: {
            line: 193,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 191,
            column: 4
          },
          end: {
            line: 193,
            column: 5
          }
        }, {
          start: {
            line: 191,
            column: 4
          },
          end: {
            line: 193,
            column: 5
          }
        }],
        line: 191
      },
      "49": {
        loc: {
          start: {
            line: 194,
            column: 4
          },
          end: {
            line: 196,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 194,
            column: 4
          },
          end: {
            line: 196,
            column: 5
          }
        }, {
          start: {
            line: 194,
            column: 4
          },
          end: {
            line: 196,
            column: 5
          }
        }],
        line: 194
      },
      "50": {
        loc: {
          start: {
            line: 203,
            column: 4
          },
          end: {
            line: 203,
            column: 60
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 203,
            column: 4
          },
          end: {
            line: 203,
            column: 60
          }
        }, {
          start: {
            line: 203,
            column: 4
          },
          end: {
            line: 203,
            column: 60
          }
        }],
        line: 203
      },
      "51": {
        loc: {
          start: {
            line: 203,
            column: 8
          },
          end: {
            line: 203,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 203,
            column: 8
          },
          end: {
            line: 203,
            column: 34
          }
        }, {
          start: {
            line: 203,
            column: 38
          },
          end: {
            line: 203,
            column: 47
          }
        }],
        line: 203
      },
      "52": {
        loc: {
          start: {
            line: 205,
            column: 21
          },
          end: {
            line: 205,
            column: 56
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 205,
            column: 33
          },
          end: {
            line: 205,
            column: 37
          }
        }, {
          start: {
            line: 205,
            column: 40
          },
          end: {
            line: 205,
            column: 56
          }
        }],
        line: 205
      },
      "53": {
        loc: {
          start: {
            line: 209,
            column: 4
          },
          end: {
            line: 209,
            column: 25
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 209,
            column: 4
          },
          end: {
            line: 209,
            column: 25
          }
        }, {
          start: {
            line: 209,
            column: 4
          },
          end: {
            line: 209,
            column: 25
          }
        }],
        line: 209
      },
      "54": {
        loc: {
          start: {
            line: 212,
            column: 17
          },
          end: {
            line: 212,
            column: 44
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 212,
            column: 27
          },
          end: {
            line: 212,
            column: 38
          }
        }, {
          start: {
            line: 212,
            column: 41
          },
          end: {
            line: 212,
            column: 44
          }
        }],
        line: 212
      },
      "55": {
        loc: {
          start: {
            line: 214,
            column: 89
          },
          end: {
            line: 214,
            column: 114
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 214,
            column: 99
          },
          end: {
            line: 214,
            column: 106
          }
        }, {
          start: {
            line: 214,
            column: 109
          },
          end: {
            line: 214,
            column: 114
          }
        }],
        line: 214
      },
      "56": {
        loc: {
          start: {
            line: 240,
            column: 18
          },
          end: {
            line: 240,
            column: 100
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 240,
            column: 79
          },
          end: {
            line: 240,
            column: 81
          }
        }, {
          start: {
            line: 240,
            column: 84
          },
          end: {
            line: 240,
            column: 100
          }
        }],
        line: 240
      },
      "57": {
        loc: {
          start: {
            line: 240,
            column: 18
          },
          end: {
            line: 240,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 240,
            column: 18
          },
          end: {
            line: 240,
            column: 42
          }
        }, {
          start: {
            line: 240,
            column: 46
          },
          end: {
            line: 240,
            column: 76
          }
        }],
        line: 240
      },
      "58": {
        loc: {
          start: {
            line: 241,
            column: 31
          },
          end: {
            line: 241,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 241,
            column: 31
          },
          end: {
            line: 241,
            column: 47
          }
        }, {
          start: {
            line: 241,
            column: 51
          },
          end: {
            line: 241,
            column: 81
          }
        }],
        line: 241
      },
      "59": {
        loc: {
          start: {
            line: 242,
            column: 22
          },
          end: {
            line: 242,
            column: 90
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 242,
            column: 22
          },
          end: {
            line: 242,
            column: 37
          }
        }, {
          start: {
            line: 242,
            column: 41
          },
          end: {
            line: 242,
            column: 50
          }
        }, {
          start: {
            line: 242,
            column: 55
          },
          end: {
            line: 242,
            column: 67
          }
        }, {
          start: {
            line: 242,
            column: 71
          },
          end: {
            line: 242,
            column: 89
          }
        }],
        line: 242
      },
      "60": {
        loc: {
          start: {
            line: 245,
            column: 6
          },
          end: {
            line: 245,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 245,
            column: 6
          },
          end: {
            line: 245,
            column: 15
          }
        }, {
          start: {
            line: 245,
            column: 19
          },
          end: {
            line: 245,
            column: 42
          }
        }],
        line: 245
      },
      "61": {
        loc: {
          start: {
            line: 246,
            column: 6
          },
          end: {
            line: 246,
            column: 54
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 246,
            column: 6
          },
          end: {
            line: 246,
            column: 16
          }
        }, {
          start: {
            line: 246,
            column: 20
          },
          end: {
            line: 246,
            column: 54
          }
        }],
        line: 246
      },
      "62": {
        loc: {
          start: {
            line: 248,
            column: 21
          },
          end: {
            line: 248,
            column: 78
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 248,
            column: 21
          },
          end: {
            line: 248,
            column: 30
          }
        }, {
          start: {
            line: 248,
            column: 34
          },
          end: {
            line: 248,
            column: 78
          }
        }],
        line: 248
      },
      "63": {
        loc: {
          start: {
            line: 251,
            column: 19
          },
          end: {
            line: 251,
            column: 72
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 251,
            column: 30
          },
          end: {
            line: 251,
            column: 60
          }
        }, {
          start: {
            line: 251,
            column: 63
          },
          end: {
            line: 251,
            column: 72
          }
        }],
        line: 251
      },
      "64": {
        loc: {
          start: {
            line: 254,
            column: 14
          },
          end: {
            line: 254,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 254,
            column: 14
          },
          end: {
            line: 254,
            column: 26
          }
        }, {
          start: {
            line: 254,
            column: 30
          },
          end: {
            line: 254,
            column: 37
          }
        }],
        line: 254
      },
      "65": {
        loc: {
          start: {
            line: 258,
            column: 23
          },
          end: {
            line: 258,
            column: 60
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 258,
            column: 44
          },
          end: {
            line: 258,
            column: 46
          }
        }, {
          start: {
            line: 258,
            column: 49
          },
          end: {
            line: 258,
            column: 60
          }
        }],
        line: 258
      },
      "66": {
        loc: {
          start: {
            line: 259,
            column: 21
          },
          end: {
            line: 259,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 259,
            column: 21
          },
          end: {
            line: 259,
            column: 23
          }
        }, {
          start: {
            line: 259,
            column: 27
          },
          end: {
            line: 259,
            column: 36
          }
        }],
        line: 259
      },
      "67": {
        loc: {
          start: {
            line: 260,
            column: 16
          },
          end: {
            line: 260,
            column: 38
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 260,
            column: 16
          },
          end: {
            line: 260,
            column: 26
          }
        }, {
          start: {
            line: 260,
            column: 30
          },
          end: {
            line: 260,
            column: 38
          }
        }],
        line: 260
      },
      "68": {
        loc: {
          start: {
            line: 261,
            column: 16
          },
          end: {
            line: 261,
            column: 51
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 261,
            column: 38
          },
          end: {
            line: 261,
            column: 42
          }
        }, {
          start: {
            line: 261,
            column: 45
          },
          end: {
            line: 261,
            column: 51
          }
        }],
        line: 261
      },
      "69": {
        loc: {
          start: {
            line: 272,
            column: 6
          },
          end: {
            line: 272,
            column: 118
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 272,
            column: 6
          },
          end: {
            line: 272,
            column: 15
          }
        }, {
          start: {
            line: 272,
            column: 19
          },
          end: {
            line: 272,
            column: 118
          }
        }],
        line: 272
      },
      "70": {
        loc: {
          start: {
            line: 272,
            column: 79
          },
          end: {
            line: 272,
            column: 114
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 272,
            column: 100
          },
          end: {
            line: 272,
            column: 109
          }
        }, {
          start: {
            line: 272,
            column: 112
          },
          end: {
            line: 272,
            column: 114
          }
        }],
        line: 272
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0, 0],
      "40": [0, 0],
      "41": [0, 0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0, 0],
      "48": [0, 0],
      "49": [0, 0],
      "50": [0, 0],
      "51": [0, 0],
      "52": [0, 0],
      "53": [0, 0],
      "54": [0, 0],
      "55": [0, 0],
      "56": [0, 0],
      "57": [0, 0],
      "58": [0, 0],
      "59": [0, 0, 0, 0],
      "60": [0, 0],
      "61": [0, 0],
      "62": [0, 0],
      "63": [0, 0],
      "64": [0, 0],
      "65": [0, 0],
      "66": [0, 0],
      "67": [0, 0],
      "68": [0, 0],
      "69": [0, 0],
      "70": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Input/Input.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import config from '../config';
import { inputTitleClass } from '../InputTitle/styles';
import cleanProps from '../utils/cleanProps';
import Clear from './clear';
import { inputClass } from './styles';
import InputTitle from '../InputTitle';

function regLength(size) {
  cov_g1cjev3dz.f[0]++;
  cov_g1cjev3dz.s[0]++;
  return (cov_g1cjev3dz.b[1][0]++, /\d+/.test(String(size))) && (cov_g1cjev3dz.b[1][1]++, size > 0) ? (cov_g1cjev3dz.b[0][0]++, "{0,".concat(size, "}")) : (cov_g1cjev3dz.b[0][1]++, '*');
}

function fillNumber(val) {
  cov_g1cjev3dz.f[1]++;
  cov_g1cjev3dz.s[1]++;
  return val.replace(/^(-)?(\.\d+)(?!=\.).*/g, '$10$2') // eslint-disable-next-line no-useless-escape
  .replace(/(-|^)0+(?=0\.?|[^0\.])/g, '$1').replace(/\.$/, '');
}

var DefaultValue = (cov_g1cjev3dz.s[2]++, {
  type: 'text'
});

var Input =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Input, _PureComponent);

  var _super = _createSuper2(Input);

  function Input(props) {
    var _this;

    _classCallCheck(this, Input);

    cov_g1cjev3dz.f[2]++;
    cov_g1cjev3dz.s[3]++;
    _this = _super.call(this, props);
    _this.enterLock = void 0;
    _this.ref = void 0;
    _this.enterPress = void 0;

    _this.defaultInfo = function (value) {
      cov_g1cjev3dz.f[3]++;
      cov_g1cjev3dz.s[11]++;

      if ((cov_g1cjev3dz.b[3][0]++, !value) || (cov_g1cjev3dz.b[3][1]++, value.length === 0)) {
        cov_g1cjev3dz.b[2][0]++;
        cov_g1cjev3dz.s[12]++;
        return null;
      } else {
        cov_g1cjev3dz.b[2][1]++;
      }

      var _ref = (cov_g1cjev3dz.s[13]++, _this.props),
          info = _ref.info;

      var text = (cov_g1cjev3dz.s[14]++, "".concat(value.length, " / ").concat(info));
      cov_g1cjev3dz.s[15]++;

      if ((cov_g1cjev3dz.b[5][0]++, typeof info === 'number') && (cov_g1cjev3dz.b[5][1]++, value.length <= info)) {
        cov_g1cjev3dz.b[4][0]++;
        cov_g1cjev3dz.s[16]++;
        return text;
      } else {
        cov_g1cjev3dz.b[4][1]++;
      }

      cov_g1cjev3dz.s[17]++;
      return new Error(text);
    };

    _this.getTrim = function () {
      cov_g1cjev3dz.f[5]++;

      var _ref2 = (cov_g1cjev3dz.s[22]++, _this.props),
          trim = _ref2.trim;

      cov_g1cjev3dz.s[23]++;

      if (trim !== undefined) {
        cov_g1cjev3dz.b[7][0]++;
        cov_g1cjev3dz.s[24]++;
        return trim;
      } else {
        cov_g1cjev3dz.b[7][1]++;
      }

      cov_g1cjev3dz.s[25]++;

      if (config.trim !== undefined) {
        cov_g1cjev3dz.b[8][0]++;
        cov_g1cjev3dz.s[26]++;
        return config.trim;
      } else {
        cov_g1cjev3dz.b[8][1]++;
      }

      cov_g1cjev3dz.s[27]++;
      return false;
    };

    cov_g1cjev3dz.s[4]++;
    _this.enterLock = false;
    cov_g1cjev3dz.s[5]++;
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    cov_g1cjev3dz.s[6]++;
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_this));
    cov_g1cjev3dz.s[7]++;
    _this.handleKeyUp = _this.handleKeyUp.bind(_assertThisInitialized(_this));
    cov_g1cjev3dz.s[8]++;
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
    cov_g1cjev3dz.s[9]++;
    _this.handleAutoSelect = _this.handleAutoSelect.bind(_assertThisInitialized(_this));
    cov_g1cjev3dz.s[10]++;
    _this.bindRef = _this.bindRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Input, [{
    key: "bindRef",
    value: function bindRef(el) {
      cov_g1cjev3dz.f[4]++;

      var _ref3 = (cov_g1cjev3dz.s[18]++, this.props),
          forwardedRef = _ref3.forwardedRef;

      cov_g1cjev3dz.s[19]++;
      this.ref = el;
      cov_g1cjev3dz.s[20]++;

      if (forwardedRef) {
        cov_g1cjev3dz.b[6][0]++;
        cov_g1cjev3dz.s[21]++;
        forwardedRef(el);
      } else {
        cov_g1cjev3dz.b[6][1]++;
      }
    }
  }, {
    key: "isValidNumber",
    value: function isValidNumber(val) {
      cov_g1cjev3dz.f[6]++;

      var _ref4 = (cov_g1cjev3dz.s[28]++, this.props),
          numType = _ref4.numType;

      var noNeg = (cov_g1cjev3dz.s[29]++, (cov_g1cjev3dz.b[9][0]++, numType === 'non-negative') || (cov_g1cjev3dz.b[9][1]++, numType === 'positive'));
      var regExp = (cov_g1cjev3dz.s[30]++, new RegExp("^(".concat(noNeg ? (cov_g1cjev3dz.b[10][0]++, '') : (cov_g1cjev3dz.b[10][1]++, '-'), ")?\\d*\\.?\\d*$"), 'g'));
      cov_g1cjev3dz.s[31]++;
      return regExp.test(val);
    }
  }, {
    key: "formatValue",
    value: function formatValue(val) {
      cov_g1cjev3dz.f[7]++;
      var value = (cov_g1cjev3dz.s[32]++, val);

      var _ref5 = (cov_g1cjev3dz.s[33]++, this.props),
          type = _ref5.type,
          digits = _ref5.digits,
          integerLimit = _ref5.integerLimit,
          numType = _ref5.numType;

      var noNeg = (cov_g1cjev3dz.s[34]++, (cov_g1cjev3dz.b[11][0]++, numType === 'non-negative') || (cov_g1cjev3dz.b[11][1]++, numType === 'positive'));
      cov_g1cjev3dz.s[35]++;

      if (type !== 'number') {
        cov_g1cjev3dz.b[12][0]++;
        cov_g1cjev3dz.s[36]++;
        return value;
      } else {
        cov_g1cjev3dz.b[12][1]++;
      }

      var regExp = (cov_g1cjev3dz.s[37]++, new RegExp("^(".concat(noNeg ? (cov_g1cjev3dz.b[13][0]++, '') : (cov_g1cjev3dz.b[13][1]++, '-'), ")?(\\d").concat(regLength(integerLimit), ")(").concat(digits !== 0 ? (cov_g1cjev3dz.b[14][0]++, "\\.\\d".concat(regLength(digits))) : (cov_g1cjev3dz.b[14][1]++, ''), ")?.*$"), 'g'));
      cov_g1cjev3dz.s[38]++;
      value = value.replace(regExp, '$1$2$3');
      cov_g1cjev3dz.s[39]++;
      return value;
    }
  }, {
    key: "fixValue",
    value: function fixValue(val) {
      cov_g1cjev3dz.f[8]++;

      var _ref6 = (cov_g1cjev3dz.s[40]++, this.props),
          type = _ref6.type,
          digits = _ref6.digits,
          autoFix = _ref6.autoFix,
          numType = _ref6.numType;

      cov_g1cjev3dz.s[41]++;

      if ((cov_g1cjev3dz.b[16][0]++, type !== 'number') || (cov_g1cjev3dz.b[16][1]++, val === '')) {
        cov_g1cjev3dz.b[15][0]++;
        cov_g1cjev3dz.s[42]++;
        return val;
      } else {
        cov_g1cjev3dz.b[15][1]++;
      }

      cov_g1cjev3dz.s[43]++;

      if (/^[.-]+$/.test(val)) {
        cov_g1cjev3dz.b[17][0]++;
        cov_g1cjev3dz.s[44]++;
        return '';
      } else {
        cov_g1cjev3dz.b[17][1]++;
      }

      var fixVal = (cov_g1cjev3dz.s[45]++, fillNumber(val));
      cov_g1cjev3dz.s[46]++;

      if ((cov_g1cjev3dz.b[19][0]++, numType === 'positive') && (cov_g1cjev3dz.b[19][1]++, Number(fixVal) <= 0)) {
        cov_g1cjev3dz.b[18][0]++;
        cov_g1cjev3dz.s[47]++;
        return '';
      } else {
        cov_g1cjev3dz.b[18][1]++;
      }

      cov_g1cjev3dz.s[48]++;

      if ((cov_g1cjev3dz.b[21][0]++, digits !== undefined) && (cov_g1cjev3dz.b[21][1]++, autoFix)) {
        cov_g1cjev3dz.b[20][0]++;
        cov_g1cjev3dz.s[49]++;

        if (digits > 0) {
          cov_g1cjev3dz.b[22][0]++;
          cov_g1cjev3dz.s[50]++;
          fixVal = parseFloat(fixVal).toFixed(digits);
        } else {
          cov_g1cjev3dz.b[22][1]++;
          cov_g1cjev3dz.s[51]++;
          fixVal = parseInt(fixVal, 10).toString();
        }
      } else {
        cov_g1cjev3dz.b[20][1]++;
      }

      cov_g1cjev3dz.s[52]++;
      return fixVal;
    }
  }, {
    key: "invalidNumber",
    value: function invalidNumber(value) {
      cov_g1cjev3dz.f[9]++;

      var _ref7 = (cov_g1cjev3dz.s[53]++, this.props),
          digits = _ref7.digits,
          type = _ref7.type,
          integerLimit = _ref7.integerLimit;

      cov_g1cjev3dz.s[54]++;

      if (type !== 'number') {
        cov_g1cjev3dz.b[23][0]++;
        cov_g1cjev3dz.s[55]++;
        return false;
      } else {
        cov_g1cjev3dz.b[23][1]++;
      }

      var reg = (cov_g1cjev3dz.s[56]++, '^-?');
      cov_g1cjev3dz.s[57]++;

      if (!integerLimit) {
        cov_g1cjev3dz.b[24][0]++;
        cov_g1cjev3dz.s[58]++;
        reg += "\\d*";
      } else {
        cov_g1cjev3dz.b[24][1]++;
        cov_g1cjev3dz.s[59]++;

        if (integerLimit > 0) {
          cov_g1cjev3dz.b[25][0]++;
          cov_g1cjev3dz.s[60]++;
          reg += "\\d{0,".concat(integerLimit, "}");
        } else {
          cov_g1cjev3dz.b[25][1]++;
        }
      }

      cov_g1cjev3dz.s[61]++;

      if (digits === undefined) {
        cov_g1cjev3dz.b[26][0]++;
        cov_g1cjev3dz.s[62]++;
        reg += '\\.?\\d*';
      } else {
        cov_g1cjev3dz.b[26][1]++;
        cov_g1cjev3dz.s[63]++;

        if (digits >= 0) {
          cov_g1cjev3dz.b[27][0]++;
          cov_g1cjev3dz.s[64]++;
          reg += "\\.?\\d{0,".concat(digits, "}");
        } else {
          cov_g1cjev3dz.b[27][1]++;
        }
      }

      cov_g1cjev3dz.s[65]++;
      reg += '$';
      cov_g1cjev3dz.s[66]++;
      reg = new RegExp(reg);
      cov_g1cjev3dz.s[67]++;
      return !reg.test(value);
    }
  }, {
    key: "handleChange",
    value: function handleChange(e, clearClick) {
      cov_g1cjev3dz.f[10]++;

      var _ref8 = (cov_g1cjev3dz.s[68]++, this.props),
          type = _ref8.type,
          clearable = _ref8.clearable,
          coin = _ref8.coin;

      cov_g1cjev3dz.s[69]++;

      if (clearClick) {
        cov_g1cjev3dz.b[28][0]++;
        cov_g1cjev3dz.s[70]++;
        this.ref.focus();
        cov_g1cjev3dz.s[71]++;

        if (typeof clearable === 'function') {
          cov_g1cjev3dz.b[29][0]++;
          cov_g1cjev3dz.s[72]++;
          clearable();
        } else {
          cov_g1cjev3dz.b[29][1]++;
        }
      } else {
        cov_g1cjev3dz.b[28][1]++;
      }

      var _ref9 = (cov_g1cjev3dz.s[73]++, e.target),
          value = _ref9.value;

      cov_g1cjev3dz.s[74]++;

      if ((cov_g1cjev3dz.b[31][0]++, clearClick) && (cov_g1cjev3dz.b[31][1]++, this.props.clearToUndefined)) {
        cov_g1cjev3dz.b[30][0]++;
        cov_g1cjev3dz.s[75]++;
        this.props.onChange(value);
        cov_g1cjev3dz.s[76]++;
        return;
      } else {
        cov_g1cjev3dz.b[30][1]++;
      }

      cov_g1cjev3dz.s[77]++;

      if (type === 'number') {
        cov_g1cjev3dz.b[32][0]++;
        cov_g1cjev3dz.s[78]++;

        if (typeof value !== 'number') {
          cov_g1cjev3dz.b[33][0]++;
          cov_g1cjev3dz.s[79]++;
          value = String(value).replace(/。/g, '.');
          cov_g1cjev3dz.s[80]++;

          if (coin) {
            cov_g1cjev3dz.b[34][0]++;
            cov_g1cjev3dz.s[81]++;
            value = value.replace(/,/g, '');
          } else {
            cov_g1cjev3dz.b[34][1]++;
          }
        } else {
          cov_g1cjev3dz.b[33][1]++;
        }

        cov_g1cjev3dz.s[82]++;

        if (!this.isValidNumber(value)) {
          cov_g1cjev3dz.b[35][0]++;
          cov_g1cjev3dz.s[83]++;
          return;
        } else {
          cov_g1cjev3dz.b[35][1]++;
        }

        cov_g1cjev3dz.s[84]++;
        value = this.formatValue(value);
      } else {
        cov_g1cjev3dz.b[32][1]++;
      }

      cov_g1cjev3dz.s[85]++;
      this.props.onChange(value);
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      cov_g1cjev3dz.f[11]++;

      var _ref10 = (cov_g1cjev3dz.s[86]++, this.props),
          onKeyDown = _ref10.onKeyDown;

      cov_g1cjev3dz.s[87]++;

      if (e.keyCode === 13) {
        cov_g1cjev3dz.b[36][0]++;
        cov_g1cjev3dz.s[88]++;
        this.enterPress = true;
      } else {
        cov_g1cjev3dz.b[36][1]++;
      }

      cov_g1cjev3dz.s[89]++;

      if (onKeyDown) {
        cov_g1cjev3dz.b[37][0]++;
        cov_g1cjev3dz.s[90]++;
        onKeyDown(e);
      } else {
        cov_g1cjev3dz.b[37][1]++;
      }
    }
  }, {
    key: "handleKeyUp",
    value: function handleKeyUp(e) {
      cov_g1cjev3dz.f[12]++;

      var _ref11 = (cov_g1cjev3dz.s[91]++, this.props),
          onKeyUp = _ref11.onKeyUp,
          onEnterPress = _ref11.onEnterPress;

      cov_g1cjev3dz.s[92]++;

      if ((cov_g1cjev3dz.b[39][0]++, this.enterPress) && (cov_g1cjev3dz.b[39][1]++, e.keyCode === 13) && (cov_g1cjev3dz.b[39][2]++, onEnterPress)) {
        cov_g1cjev3dz.b[38][0]++;
        cov_g1cjev3dz.s[93]++;
        onEnterPress(e.target.value, e);
        cov_g1cjev3dz.s[94]++;
        this.enterPress = false;
      } else {
        cov_g1cjev3dz.b[38][1]++;
      }

      cov_g1cjev3dz.s[95]++;

      if (onKeyUp) {
        cov_g1cjev3dz.b[40][0]++;
        cov_g1cjev3dz.s[96]++;
        onKeyUp(e);
      } else {
        cov_g1cjev3dz.b[40][1]++;
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      cov_g1cjev3dz.f[13]++;

      var _ref12 = (cov_g1cjev3dz.s[97]++, e.target),
          value = _ref12.value;

      var _ref13 = (cov_g1cjev3dz.s[98]++, this.props),
          forceChange = _ref13.forceChange,
          onChange = _ref13.onChange,
          onBlur = _ref13.onBlur,
          clearToUndefined = _ref13.clearToUndefined;

      var newVal = (cov_g1cjev3dz.s[99]++, this.fixValue(value));
      var shouldKeepUndefined = (cov_g1cjev3dz.s[100]++, (cov_g1cjev3dz.b[41][0]++, clearToUndefined) && (cov_g1cjev3dz.b[41][1]++, newVal === '') && (cov_g1cjev3dz.b[41][2]++, this.props.value === undefined));
      cov_g1cjev3dz.s[101]++;

      if ((cov_g1cjev3dz.b[43][0]++, !shouldKeepUndefined) && (cov_g1cjev3dz.b[43][1]++, !this.invalidNumber(newVal))) {
        cov_g1cjev3dz.b[42][0]++;
        cov_g1cjev3dz.s[102]++;

        if (this.getTrim()) {
          cov_g1cjev3dz.b[44][0]++;
          cov_g1cjev3dz.s[103]++;
          newVal = newVal.trim();
        } else {
          cov_g1cjev3dz.b[44][1]++;
        }

        var change = (cov_g1cjev3dz.s[104]++, (cov_g1cjev3dz.b[45][0]++, forceChange) || (cov_g1cjev3dz.b[45][1]++, onChange)); // @ts-ignore cancelBlurChange 内部属性

        cov_g1cjev3dz.s[105]++;

        if (!this.props.cancelBlurChange) {
          cov_g1cjev3dz.b[46][0]++;
          cov_g1cjev3dz.s[106]++;
          change(newVal);
        } else {
          cov_g1cjev3dz.b[46][1]++;
        }

        cov_g1cjev3dz.s[107]++;
        e.target.value = newVal;
      } else {
        cov_g1cjev3dz.b[42][1]++;
      }

      cov_g1cjev3dz.s[108]++;

      if (onBlur) {
        cov_g1cjev3dz.b[47][0]++;
        cov_g1cjev3dz.s[109]++;
        onBlur(e);
      } else {
        cov_g1cjev3dz.b[47][1]++;
      }
    }
  }, {
    key: "handleAutoSelect",
    value: function handleAutoSelect(event) {
      cov_g1cjev3dz.f[14]++;

      var _ref14 = (cov_g1cjev3dz.s[110]++, this.props),
          onFocus = _ref14.onFocus;

      var _ref15 = (cov_g1cjev3dz.s[111]++, this.props),
          autoSelect = _ref15.autoSelect;

      cov_g1cjev3dz.s[112]++;

      if (autoSelect) {
        cov_g1cjev3dz.b[48][0]++;
        ;
        cov_g1cjev3dz.s[113]++;
        event.currentTarget.select();
      } else {
        cov_g1cjev3dz.b[48][1]++;
      }

      cov_g1cjev3dz.s[114]++;

      if (typeof onFocus === 'function') {
        cov_g1cjev3dz.b[49][0]++;
        cov_g1cjev3dz.s[115]++;
        onFocus(event);
      } else {
        cov_g1cjev3dz.b[49][1]++;
      }
    }
  }, {
    key: "renderInfo",
    value: function renderInfo() {
      cov_g1cjev3dz.f[15]++;

      var _ref16 = (cov_g1cjev3dz.s[116]++, this.props),
          info = _ref16.info;

      var notNumber = (cov_g1cjev3dz.s[117]++, typeof info !== 'number');
      cov_g1cjev3dz.s[118]++;

      if ((cov_g1cjev3dz.b[51][0]++, typeof info !== 'function') && (cov_g1cjev3dz.b[51][1]++, notNumber)) {
        cov_g1cjev3dz.b[50][0]++;
        cov_g1cjev3dz.s[119]++;
        return null;
      } else {
        cov_g1cjev3dz.b[50][1]++;
      }

      var textInfo = (cov_g1cjev3dz.s[120]++, notNumber ? (cov_g1cjev3dz.b[52][0]++, info) : (cov_g1cjev3dz.b[52][1]++, this.defaultInfo));
      var res = (cov_g1cjev3dz.s[121]++, textInfo(this.props.value)); // empty

      cov_g1cjev3dz.s[122]++;

      if (!res) {
        cov_g1cjev3dz.b[53][0]++;
        cov_g1cjev3dz.s[123]++;
        return null;
      } else {
        cov_g1cjev3dz.b[53][1]++;
      }

      var isError = (cov_g1cjev3dz.s[124]++, res instanceof Error);
      var text = (cov_g1cjev3dz.s[125]++, isError ? (cov_g1cjev3dz.b[54][0]++, res.message) : (cov_g1cjev3dz.b[54][1]++, res));
      cov_g1cjev3dz.s[126]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          key: "info",
          style: {
            minWidth: 'auto'
          },
          className: inputClass('bottom-right', isError ? (cov_g1cjev3dz.b[55][0]++, 'error') : (cov_g1cjev3dz.b[55][1]++, 'tip')),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 214,
            columnNumber: 7
          }
        }, text)
      );
    }
  }, {
    key: "render",
    value: function render() {
      cov_g1cjev3dz.f[16]++;

      var _ref17 = (cov_g1cjev3dz.s[127]++, this.props),
          type = _ref17.type,
          defaultValue = _ref17.defaultValue,
          digits = _ref17.digits,
          className = _ref17.className,
          clearable = _ref17.clearable,
          htmlName = _ref17.htmlName,
          forceChange = _ref17.forceChange,
          onEnterPress = _ref17.onEnterPress,
          forwardedRef = _ref17.forwardedRef,
          innerTitle = _ref17.innerTitle,
          inputFocus = _ref17.inputFocus,
          clearToUndefined = _ref17.clearToUndefined,
          placeholder = _ref17.placeholder,
          coin = _ref17.coin,
          cancelBlurChange = _ref17.cancelBlurChange,
          other = _objectWithoutProperties(_ref17, ["type", "defaultValue", "digits", "className", "clearable", "htmlName", "forceChange", "onEnterPress", "forwardedRef", "innerTitle", "inputFocus", "clearToUndefined", "placeholder", "coin", "cancelBlurChange"]);

      var value = (cov_g1cjev3dz.s[128]++, (cov_g1cjev3dz.b[57][0]++, this.props.value == null) || (cov_g1cjev3dz.b[57][1]++, this.props.value === undefined) ? (cov_g1cjev3dz.b[56][0]++, '') : (cov_g1cjev3dz.b[56][1]++, this.props.value));
      var needClearUndefined = (cov_g1cjev3dz.s[129]++, (cov_g1cjev3dz.b[58][0]++, clearToUndefined) && (cov_g1cjev3dz.b[58][1]++, this.props.value !== undefined));
      var showClear = (cov_g1cjev3dz.s[130]++, (cov_g1cjev3dz.b[59][0]++, !other.disabled) && (cov_g1cjev3dz.b[59][1]++, clearable) && ((cov_g1cjev3dz.b[59][2]++, value !== '') || (cov_g1cjev3dz.b[59][3]++, needClearUndefined)));
      var mc = (cov_g1cjev3dz.s[131]++, classnames(className, (cov_g1cjev3dz.b[60][0]++, showClear) && (cov_g1cjev3dz.b[60][1]++, inputClass('clearable')), (cov_g1cjev3dz.b[61][0]++, innerTitle) && (cov_g1cjev3dz.b[61][1]++, inputTitleClass('hidable', 'item'))));
      var isNumber = (cov_g1cjev3dz.s[132]++, (cov_g1cjev3dz.b[62][0]++, className) && (cov_g1cjev3dz.b[62][1]++, className.indexOf(inputClass('number')) > -1));
      cov_g1cjev3dz.s[133]++;
      return [
      /*#__PURE__*/
      React.createElement(InputTitle, {
        className: isNumber ? (cov_g1cjev3dz.b[63][0]++, inputClass('number-title-box')) : (cov_g1cjev3dz.b[63][1]++, undefined),
        key: "input",
        innerTitle: innerTitle,
        open: (cov_g1cjev3dz.b[64][0]++, !!inputFocus) || (cov_g1cjev3dz.b[64][1]++, !!value),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 250,
          columnNumber: 7
        }
      },
      /*#__PURE__*/
      React.createElement("input", Object.assign({}, cleanProps(other), {
        placeholder: needClearUndefined ? (cov_g1cjev3dz.b[65][0]++, '') : (cov_g1cjev3dz.b[65][1]++, placeholder),
        className: (cov_g1cjev3dz.b[66][0]++, mc) || (cov_g1cjev3dz.b[66][1]++, undefined),
        name: (cov_g1cjev3dz.b[67][0]++, other.name) || (cov_g1cjev3dz.b[67][1]++, htmlName),
        type: type === 'password' ? (cov_g1cjev3dz.b[68][0]++, type) : (cov_g1cjev3dz.b[68][1]++, 'text'),
        value: value,
        ref: this.bindRef,
        key: "input",
        onChange: this.handleChange,
        onKeyDown: this.handleKeyDown,
        onKeyUp: this.handleKeyUp,
        onBlur: this.handleBlur,
        onFocus: this.handleAutoSelect,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 256,
          columnNumber: 9
        }
      }))), (cov_g1cjev3dz.b[69][0]++, showClear) && (cov_g1cjev3dz.b[69][1]++,
      /*#__PURE__*/
      React.createElement(Clear, {
        onClick: this.handleChange,
        key: "close",
        clearResult: needClearUndefined ? (cov_g1cjev3dz.b[70][0]++, undefined) : (cov_g1cjev3dz.b[70][1]++, ''),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 272,
          columnNumber: 20
        }
      })), this.renderInfo()];
    }
  }]);

  return Input;
}(PureComponent);

Input.defaultProps = DefaultValue;
export default Input;